import React from 'react';
import {
  Home,
  Book,
  Gamepad2,
  Folder,
  User,
  Menu,
  X,
  Grid3X3,
  Image,
  Link,
  Search,
  Play,
  Download,
  Check,
  Plus,
  Minus,
  Pencil,
  Trash2,
  Settings,
  LogOut,
  CheckCircle,
  XCircle,
  AlertTriangle,
  Info,
  Lock,
  Unlock,
  Video,
  FileText,
  Clipboard,
  BookOpen,
  BarChart3,
  Trophy,
  Star,
  Clock,
  Calendar,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  Hand,
  Sparkles,
  PartyPopper,
  CheckSquare,
  Mic,
  Volume2,
  VolumeX,
  Brain,
  Heart,
  Smile,
  Puzzle,
  RotateCcw
} from 'lucide-react';
import { GiTongue } from 'react-icons/gi';

function Icon({ name, size = 'md', className = '', color, ...props }) {
  const sizeMap = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32
  };

  const iconMap = {
    // Navigation icons
    'home': Home,
    'modules': Book,
    'games': Gamepad2,
    'materials': Folder,
    'profile': User,
    'menu': Menu,
    'close': X,
    'brain': Brain,
    
    // Game icons
    'memory': Grid3X3,
    'story': Image,
    'wordmatch': Link,
    'search': Search,
    'target': Grid3X3,
    'microphone': Mic,
    'speaker': Volume2,
    'volume-on': Volume2,
    'volume-off': VolumeX,
    'puzzle': Puzzle,
    
    // Action icons
    'play': Play,
    'download': Download,
    'check': Check,
    'plus': Plus,
    'minus': Minus,
    'edit': Pencil,
    'delete': Trash2,
    'settings': Settings,
    'logout': LogOut,
    'refresh': RotateCcw,
    
    // Status icons
    'success': CheckCircle,
    'error': XCircle,
    'warning': AlertTriangle,
    'info': Info,
    'lock': Lock,
    'unlock': Unlock,
    
    // Learning icons
    'video': Video,
    'document': FileText,
    'task': Clipboard,
    'explanation': BookOpen,
    'worksheet': FileText,
    'progress': BarChart3,
    'trophy': Trophy,
    'star': Star,
    'clock': Clock,
    'calendar': Calendar,
    
    // Direction icons
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'arrow-up': ArrowUp,
    'arrow-down': ArrowDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    'chevron-down': ChevronDown,
    
    // Misc icons
    'wave': Hand,
    'sparkle': Sparkles,
    'confetti': PartyPopper,
    'checklist': CheckSquare,
    'mouth': Smile,
    'ear': Volume2,
    'heart': Heart,
    'smile': Smile,
    'tongue': GiTongue
  };

  const IconComponent = iconMap[name];
  
  // Handle special case for tongue icon from react-icons
  if (name === 'tongue') {
    return (
      <GiTongue 
        size={sizeMap[size]}
        color={color}
        className={`icon ${className}`}
        {...props}
      />
    );
  }
  
  // Adjust stroke width based on size - larger icons get thinner strokes
  const strokeWidth = size === 'xl' ? 1.5 : size === 'lg' ? 1.75 : 2;
  
  if (!IconComponent) {
    return (
      <div 
        className={`icon ${className}`}
        style={{ width: sizeMap[size], height: sizeMap[size], display: 'inline-block' }}
        {...props}
      >
        ●
      </div>
    );
  }
  
  return (
    <IconComponent 
      size={sizeMap[size]}
      strokeWidth={strokeWidth}
      color={color}
      className={`icon ${className}`}
      {...props}
    />
  );
}

export default Icon;